import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isManager } from "../utils/helpers";

/**
 * HomeRedirect - Componente que redireciona o usuário para a home correta
 * baseado no seu perfil (Gestor ou Jogador).
 */
export function HomeRedirect() {
  const { user, loadingUserData } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Não fazer nada enquanto está carregando os dados do usuário
    if (loadingUserData || !user) {
      return;
    }

    // Verificar se o usuário é gestor
    if (isManager(user)) {
      navigate("/gestao", { replace: true });
    } else {
      navigate("/home", { replace: true });
    }
  }, [user, loadingUserData, navigate]);

  // Mostrar loading enquanto verifica
  if (loadingUserData) {
    return null; // ou um componente de loading
  }

  return null;
}
